var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
var PassThrought = function (_a) {
    var children = _a.children;
    return children;
};
var MediaServerSide = /** @class */ (function (_super) {
    __extends(MediaServerSide, _super);
    function MediaServerSide() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            key: 'media-as-predicted',
        };
        return _this;
    }
    MediaServerSide.prototype.componentDidMount = function () {
        var _a = this.props, fact = _a.fact, predicted = _a.predicted, hydrated = _a.hydrated;
        if (fact && fact !== predicted) {
            if (hydrated) {
                this.setState({
                    key: 'media-prediction-failed',
                });
            }
            // tslint:disable-next-line:no-console
            console.error("React-media-match: SSR failed \"" + predicted + "\" was predicted, while \"" + fact + "\" seen by fact.");
        }
    };
    MediaServerSide.prototype.render = function () {
        return React.createElement(PassThrought, { key: this.state.key }, this.props.children);
    };
    return MediaServerSide;
}(React.Component));
export { MediaServerSide };
